import './Filter.scss'

import {parse, stringify} from 'query-string'
import React from 'react'
import {useHistory, useLocation} from 'react-router'
import {useTranslation} from 'util/i18n'
import {style} from 'util/style'
import {Dropdown, OptionType} from 'views/ui/Dropdown'
import {ScrollMemory} from '../../util/scrollmemory'

const styles = style('filter', ['empty'])

export type FilterType = Array<OptionType>
export const Filter: React.FC<{
	filters: FilterType
	filterKey: string
	label?: string
	reset?: string
}> = ({label, filters, filterKey}) => {
	const hasFilters = filters?.length > 0

	if (!hasFilters) return null

	const location = useLocation()
	const history = useHistory()

	const locationSearch = parse(location.search)

	const chosenGroup = locationSearch[filterKey]

	const chosenGroupData =
		hasFilters && filters.find(({path}) => path === chosenGroup)
	return (
		<div className={styles}>
			{label && (
				<label
					className={styles('label')}
					htmlFor={filterKey + 'choose-material-for'}
				>
					{label}
				</label>
			)}
			<div className={styles('dropdown')}>
				<Dropdown
					onChange={(val) => {
						locationSearch[filterKey] = val
						const search = stringify(locationSearch)
						if (locationSearch[filterKey]) {
							ScrollMemory.IGNORE_SCROLL = true
							history.push({search})
							setTimeout(() => (ScrollMemory.IGNORE_SCROLL = false), 100)
						}
					}}
					mod={'boldtext'}
					selected={chosenGroupData || null}
					items={filters}
					customInputId={filterKey + 'choose-material-for'}
					customLabelName={chosenGroupData?.title}
					defaultText={' '}
					allowClearSelection
					noMaxHeight
				/>
			</div>
		</div>
	)
}

export const FilterEmpty: React.FC = ({children}) => {
	const t = useTranslation('webshop').filter

	return (
		<div className={styles.empty}>
			<p className={styles.empty('text')}>{children || t.empty}</p>
		</div>
	)
}
